import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useIsSupplyTargetingSelectPermitted } from './useIsSupplyTargetingSelectPermitted';

export const useIsSupplyTargetingPermitted = () => {
    const isSupplyPermitted = useConfigMatch({ [FEATURE_FLAGS.SUPPLY_TARGETING_ENABLED]: 'true' });
    const isSupplySliderPermitted = useConfigMatch({ [FEATURE_FLAGS.SUPPLY_TARGETING_SLIDER_ENABLED]: 'true' });
    const isTaboolaSelectEnabled = useIsSupplyTargetingSelectPermitted();
    const isPermitted = isSupplyPermitted || isTaboolaSelectEnabled;
    if (!isPermitted) {
        return null;
    }
    return { isSupplyPermitted, isTaboolaSelectEnabled, isSupplySliderPermitted };
};
